import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-sm">
                桃
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                红桃影视大全
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              汇聚海量欧美热门剧集，1080P超清画质，中英双语字幕，随时随地免费在线畅看。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门分类</h4>
            <div className="flex flex-col gap-2">
              {["悬疑", "动作", "爱情", "科幻", "喜剧", "恐怖"].map((cat) => (
                <Link
                  key={cat}
                  to={`/category/${cat === "悬疑" ? "xuanyi" : cat === "动作" ? "dongzuo" : cat === "爱情" ? "aiqing" : cat === "科幻" ? "kehuan" : cat === "喜剧" ? "xiju" : "kongbu"}`}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat}欧美剧
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">帮助中心</a>
              <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系方式</h4>
            <div className="flex flex-col gap-3 text-sm text-background-50/60">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@hongtao-tv.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-8888</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区传媒产业园</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-50/40">
          <p>&copy; {currentYear} 红桃影视大全 版权所有</p>
          <p>红桃影视大全高清欧美剧 - 免费在线观看平台</p>
        </div>
      </div>
    </footer>
  );
}